import { useLazyLoadQuery } from 'react-relay';
import { UNIFIED_ACCOUNT_QUERY } from '../constants';
import { UnifiedAccountQuery } from 'graphql/__generated__/UnifiedAccountQuery.graphql';
import useLoggedInUser from './useLoggedInUser';

const useHasLinkedAccounts = (): boolean => {
  const loggedInUser = useLoggedInUser();
  const accountId = loggedInUser?.accountId || '';

  if (!accountId) {
    return false;
  }

  const account = useLazyLoadQuery<UnifiedAccountQuery>(
    UNIFIED_ACCOUNT_QUERY,
    { aaid: accountId },
    { fetchPolicy: 'store-or-network' },
  ).unified;

  return Boolean(account?.account?.isLinked);
};

export default useHasLinkedAccounts;
